"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.dfltSettings = exports.serializeAstroSettings = exports.deserializeAstroSettings = void 0;
function deserializeAstroSettings(data) {
    var maps = {};
    Object.keys(data.maps).forEach(function (mapId) {
        var map = data.maps[mapId];
        var orbises = {};
        Object.keys(map.orbises).forEach(function (aspType) {
            orbises[+aspType] = map.orbises[aspType]
                .split(' ')
                .map(function (orb) {
                var disabled = orb[0] == '!';
                var major = orb[0] == '*';
                return {
                    disabled: disabled,
                    major: major,
                    value: +(disabled || major ? orb.substr(1) : orb)
                };
            });
        });
        maps[mapId] = {
            orbises: orbises,
            orbiseCorrector: map.orbiseCorrector
        };
    });
    return __assign(__assign({}, data), { maps: maps });
}
exports.deserializeAstroSettings = deserializeAstroSettings;
function serializeAstroSettings(data) {
    var maps = {};
    Object.keys(data.maps).forEach(function (mapId) {
        var orbises = {};
        var map = data.maps[mapId];
        Object.keys(map.orbises).forEach(function (aspType) {
            orbises[+aspType] = map.orbises[+aspType]
                .map(function (o) { return "".concat(o.major ? '+' : '').concat(o.disabled ? '!' : '').concat(o.value); })
                .join(' ');
        });
        maps[mapId] = {
            orbises: orbises,
            orbiseCorrector: map.orbiseCorrector
        };
    });
    var res = __assign(__assign({}, data), { maps: maps });
    delete res.id;
    delete res.mutable;
    return res;
}
exports.serializeAstroSettings = serializeAstroSettings;
exports.dfltSettings = {
    'title': 'Школа Павла Андреева',
    'overSign': 70,
    'isRounded': true,
    'overSign0': 50,
    'northernLatitude': 61.75,
    'housesSystem': {
        'common': 0,
        'northern': 3,
        'horar': 2
    },
    'maps': {
        'natal': {
            'orbises': {
                '0': '10 9 5 5 5 7 5 5 5 5 !5 !5 !0 !4',
                '30': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '36': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '40': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '45': '1.5 1 1 1 1 1 1 1 1 1 !1 !1 !0 !0',
                '60': '10 9 5 5 5 7 5 5 5 5 !5 !5 !0 !4',
                '72': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '80': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '90': '10 9 5 5 5 7 5 5 5 5 !5 !5 !0 !4',
                '100': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '108': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '120': '10 9 5 5 5 7 5 5 5 5 !5 !5 !0 !4',
                '135': '1 1 1 1 1 1 1 1 1 1 !1 !1 !0 !0',
                '144': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '150': '3 2 1 1 1 1 1 1 1 1 !1 !1 !0 !0',
                '180': '10 9 5 5 5 7 5 5 5 5 !5 !5 !0 !4'
            },
            'orbiseCorrector': 0
        },
        'transits': {
            'orbises': {
                '0': '2 2 2 2 2 2 2 2 2 2 2 2 2 2',
                '30': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '36': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '40': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '45': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '60': '2 2 2 2 2 2 2 2 2 2 2 2 2 2',
                '72': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '80': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '90': '2 2 2 2 2 2 2 2 2 2 2 2 2 2',
                '100': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '108': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '120': '2 2 2 2 2 2 2 2 2 2 2 2 2 2',
                '135': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '144': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '150': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '180': '2 2 2 2 2 2 2 2 2 2 2 2 2 2'
            },
            'orbiseCorrector': 0
        },
        'directions': {
            'orbises': {
                '0': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1',
                '30': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '36': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '40': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '45': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '60': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1',
                '72': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '80': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '90': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1',
                '100': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '108': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '120': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1',
                '135': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '144': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '150': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '180': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1'
            },
            'orbiseCorrector': 0
        },
        'solars': {
            'orbises': {
                '0': '2 2 2 2 2 2 2 2 2 2 2 2 !0 2',
                '30': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '36': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '40': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '45': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '60': '2 2 2 2 2 2 2 2 2 2 2 2 !0 2',
                '72': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '80': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '90': '2 2 2 2 2 2 2 2 2 2 2 2 !0 2',
                '100': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '108': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '120': '2 2 2 2 2 2 2 2 2 2 2 2 !0 2',
                '135': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '144': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '150': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '180': '2 2 2 2 2 2 2 2 2 2 2 2 !0 2'
            },
            'orbiseCorrector': 0
        },
        'progressions': {
            'orbises': {
                '0': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1',
                '30': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '36': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '40': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '45': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '60': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1',
                '72': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '80': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '90': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1',
                '100': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '108': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '120': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1',
                '135': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '144': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '150': '1 1 1 1 1 1 1 1 1 1 1 1 !0 1',
                '180': '2 1.5 1 1 1 1 1 1 1 1 1 1 !0 1'
            },
            'orbiseCorrector': 0
        },
        'synastry': {
            'orbises': {
                '0': '10 9 5 5 5 7 5 5 5 5 5 5 !0 !4',
                '30': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '36': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '40': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '45': '1.5 1 1 1 1 1 1 1 1 1 1 1 !0 !0',
                '60': '10 9 5 5 5 7 5 5 5 5 5 5 !0 !4',
                '72': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '80': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '90': '10 9 5 5 5 7 5 5 5 5 5 5 !0 !4',
                '100': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '108': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '120': '10 9 5 5 5 7 5 5 5 5 5 5 !0 !4',
                '135': '1 1 1 1 1 1 1 1 1 1 1 1 !0 !0',
                '144': '!0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0 !0',
                '150': '3 2 1 1 1 1 1 1 1 1 1 1 !0 !0',
                '180': '10 9 5 5 5 7 5 5 5 5 5 5 !0 !4'
            },
            'orbiseCorrector': -60
        }
    }
};
